import {ErrorBoundary} from "react-error-boundary";
import {EditDiscountPageLayout} from "../../../../discounts/useCases/update-discount-code/layout";
import {EditDiscountPageV2} from "../../../../discounts/useCases/update-discount-code/page-v2";
import {Alert, Button} from "antd";
import {DashboardWrapper} from "../../../../layouts/dashboard-wrapper";

export function EditDiscountCodePage() {
  return (
    <DashboardWrapper pageTitle="Edit discount code">
      <ErrorBoundary
        FallbackComponent={({error, resetErrorBoundary}) => (
          <div>
            <Alert
              message="Sorry, something went wrong."
              showIcon
              description={error.message}
              type="error"
              action={
                <Button
                  onClick={() => {
                    resetErrorBoundary();
                  }}
                  size="small"
                  danger
                >
                  Reset
                </Button>
              }
            />
          </div>
        )}
      >
        <EditDiscountPageLayout title="Discount code information">
          <EditDiscountPageV2 />
        </EditDiscountPageLayout>
      </ErrorBoundary>
    </DashboardWrapper>
  );
}
